<button type="button" class="flex shrink-0 items-center cursor-pointer" [ngClass]="buttonClass()" (click)="create.emit()" [tooltip]="iconOnly() ? literalService.get('suggestions.newTicket', true) : ''" [position]="TooltipPosition.BELOW">
    <img [src]="images.suggestions.addSuggestion" alt="newTicket" class="h-6 w-6 shrink-0" [ngClass]="{'mr-2': !iconOnly()}" />
    @if (!iconOnly()) {
        <label class="cursor-pointer">{{ literalService.get('suggestions.newTicket', true) }}</label>
    }
</button>
